var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shu.shu)?_c('img',{staticClass:"zidingyi_tu",style:(_vm.yangshi),attrs:{"src":_vm.shu.shu.tu}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }